import { ECounterPosition } from '@cian/frontend-fullscreen-carousel-component';

export const fullscreenMediaSettings = [
  {
    minWidth: -Infinity,
    maxWidth: 641,
    options: {
      defaultControls: [],
      hideThumbnails: true,
      counterPosition: ECounterPosition.HEADER,
    },
  },
  {
    minWidth: 641,
    maxWidth: Infinity,
    options: {
      hideThumbnails: false,
    },
  },
];
